import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UserService} from "./user-services/user.service";
import {CookieService} from "ngx-cookie-service";
import {GlobalConstantsComponent} from "../shared/global-constants/global-constants.component";
import {isPlatformServer} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class TiktokService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
    private userService : UserService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: any,

  ) { }


  sendPageView(action,url,userId, page_name) {
    if (isPlatformServer(this.platformId)) {
      const client_ip_adress = this.userService.getIPAddress();
      const client_user_agent = window.navigator.userAgent;
      const ttp = this.cookieService.get('_ttp');
      const ttclid = this.cookieService.get('_ttclid');
      const req = {
        event_name: action,
        user_id: userId,
        url: url,
        client_ip_adress: client_ip_adress,
        client_user_agent: client_user_agent,
        ttp: ttp,
        ttclid: ttclid,
        page_name: page_name
      };
      return this.http.post(`${this.apiUrl}tiktok/sendPageView`, req);
    }
  }
}
